<template>
  <b-dropdown
    split
    split-variant="outline-primary"
    variant="primary"
    :text="controller.textSelection"
    class="mt-1 combobox-config shadow-sm"
    size="sm"
    :disabled="controller.options.length === 0 || disabled"
  >
    <b-dropdown-item
      v-for="option in controller.options" 
      :key="option.value" 
      :value="option.value"
      @click="controller.changeSelection(option.text,option.value);setConfigReportModifiedReportViewer()"
    >
      {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SimpleDropdownConfiguration',
  props: {
    controller:{
      type:Object,
      required: true
    },
    disabled:{
      type:Boolean,
      required:false,
      default: false
    }
  },
  methods:{
    ...mapActions(['setConfigReportModifiedReportViewer']),
  }
}
</script>

<style scoped>
.combobox-config{
  min-width: 4rem;
}  
</style>